import React, { useEffect, useMemo } from 'react';

import { useBaseEventProperties } from '~hooks/selectors/useBaseEventProperties';

import {
	ConfiningBillingDelinquencyTier,
	DELINQUENCY_MODAL_ACTION_TEXT,
	DELINQUENCY_MODAL_COPY,
} from '~constants/billing/delinquency';
import { BILLING_EVENTS } from '~constants/fullstory/events/billing';
import { trackEvent } from '~third-party/fullstory';

import { BaseBillingSuspensionModal } from './BaseBillingSuspensionModal';

interface BillingDelinquencyModalProps {
	tier: ConfiningBillingDelinquencyTier;
	onDismiss: () => void;
}

/** Dismissable on purpose: the route gate, not this modal, keeps the Owner on billing. */
export const BillingDelinquencyModal = ({
	tier,
	onDismiss,
}: BillingDelinquencyModalProps): React.JSX.Element => {
	const baseEventProperties = useBaseEventProperties();

	const { eyebrow, title, body } = DELINQUENCY_MODAL_COPY[tier];
	const eventProperties = useMemo(
		() => ({ ...baseEventProperties, tier }),
		[baseEventProperties, tier],
	);

	useEffect(() => {
		trackEvent(BILLING_EVENTS.DELINQUENCY_MODAL_VIEWED, eventProperties);
	}, [eventProperties]);

	return (
		<BaseBillingSuspensionModal
			eyebrow={eyebrow}
			title={title}
			submitText={DELINQUENCY_MODAL_ACTION_TEXT}
			onSubmit={() => {
				trackEvent(BILLING_EVENTS.DELINQUENCY_MODAL_CLICKED, eventProperties);
				// The Owner is already on Billing, where the payment methods are edited.
				onDismiss();
			}}
			onDismiss={() => {
				trackEvent(BILLING_EVENTS.DELINQUENCY_MODAL_DISMISSED, eventProperties);
				onDismiss();
			}}
		>
			{body}
		</BaseBillingSuspensionModal>
	);
};
